const state = {
	overlays: {},
};

export default state;



// WEBPACK FOOTER //
// ./scripts/sky-lightbox/store/state.js